export const TOGGLE_ACC_TYPE = 'TOGGLE_ACC_TYPE'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SIGNUP = 'SIGNUP'
export const SETUP_DATA = 'SETUP_DATA'
